module.exports = __webpack_public_path__ + "static/img/ai_loading.7b89f51.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ai_loading.gif
// module id = lnWu
// module chunks = 228